import { render } from "./DeleteMerchantDialog.vue?vue&type=template&id=d854a958&scoped=true"
import script from "./DeleteMerchantDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMerchantDialog.vue?vue&type=script&lang=js"

import "./DeleteMerchantDialog.vue?vue&type=style&index=0&id=d854a958&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d854a958"]])

export default __exports__